import { UPLOAD_ART_VIEW } from '@app/constants';
import Router from './router';

const basename = document.location.pathname.replace(/\/target;.*/, '');

const defaultState = {
  view: UPLOAD_ART_VIEW,
};

const router = new Router({
  basename,
  defaultState,
  order: ['target', 'design', 'customize', 'ctx'],
});

export const navigate = (view, matrix, replace) => {
  router[replace ? 'replace' : 'push'](
    {
      matrix,
      view,
    },
    true,
  );
};

export const navigateToView = (
  view,
  { relativePath, storageId },
  productId = null,
  ctx = {
    force: null,
    product: null,
    design: null,
  },
) => {
  navigate(
    view,
    {
      design: {
        product: productId,
        category: null,
      },
      customize: {
        project: null,
        path: relativePath,
        storage: storageId,
      },
      ctx,
    },
    true,
  );
};

export const updateMatrixState = (matrix, params = {}) => {
  const { view, design, ctx, customize } = matrix;

  navigate(view, {
    ctx: {
      ...ctx,
      ...params.ctx,
    },
    design: {
      ...design,
      ...params.design,
    },
    customize: {
      ...customize,
      ...params.customize,
    }
  }, true);
};

export default router;
